import React from "react";
import { useTranslation } from "react-i18next";
import { Radio, Typography } from "antd";
import {
  LockOutlined,
  GlobalOutlined,
  TeamOutlined,
  UserOutlined,
} from "@ant-design/icons";

const { Title, Text } = Typography;

// CORRECCIÓN: Nombre en PascalCase
export function Step3Visibility({ data, onChange, user }) {
  const { t } = useTranslation("rooms");

  const isAdminRevi = user?.roleAdminRevi === true;

  // El `value` es el DATO que se guarda; solo `label` y `desc` son interfaz.
  const options = [
    {
      value: "private",
      label: t("asistenteTerapia.paso3.privado"),
      icon: <UserOutlined />,
      desc: t("asistenteTerapia.paso3.privadoDescripcion"),
    },
    {
      value: "public",
      label: t("asistenteTerapia.paso3.institucion"),
      icon: <TeamOutlined />,
      desc: t("asistenteTerapia.paso3.institucionDescripcion"),
    },
    {
      value: "global",
      label: t("asistenteTerapia.paso3.global"),
      icon: <GlobalOutlined />,
      desc: t("asistenteTerapia.paso3.globalDescripcion"),
      disabled: !isAdminRevi,
    },
  ];

  return (
    <div className="wizard-step">
      <Title level={5} style={{ marginBottom: 24 }}>
        {t("asistenteTerapia.paso3.titulo")}
      </Title>

      <div className="visibility-options">
        {options.map((opt) => {
          const isSelected = data.visibility === opt.value;
          const isDisabled = opt.disabled;

          return (
            <div
              key={opt.value}
              className={`vis-card ${isSelected ? "selected" : ""} ${isDisabled ? "disabled" : ""}`}
              onClick={() => !isDisabled && onChange("visibility", opt.value)}
            >
              <div className="vis-icon">{opt.icon}</div>
              <div className="vis-content">
                <Text strong>{opt.label}</Text>
                <Text type="secondary" style={{ fontSize: 12 }}>
                  {opt.desc}
                </Text>
              </div>
              <div className="vis-radio">
                <Radio checked={isSelected} disabled={isDisabled} />
              </div>

              {isDisabled && (
                <div className="lock-badge">
                  <LockOutlined /> {t("asistenteTerapia.paso3.soloAdmin")}
                </div>
              )}
            </div>
          );
        })}
      </div>
    </div>
  );
}
